import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SERVICES } from "../data/content";

const Services = () => {
  return (
    <section id="services" className="relative py-24 sm:py-32 lg:py-40" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-16">
          <Reveal className="lg:sticky lg:top-32 lg:self-start">
            <Eyebrow>05 — Services</Eyebrow>
            <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              End-to-end enterprise delivery.
            </h2>
            <p className="mt-5 text-muted-foreground">
              From architecture and integration to AI development and cloud migration — a single
              partner across the full lifecycle.
            </p>
          </Reveal>

          <div className="lg:col-span-2">
            <div className="divide-y divide-border border-y border-border">
              {SERVICES.map((service, i) => (
                <motion.a
                  key={service}
                  href="#contact"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: (i % 6) * 0.04 }}
                  className="group flex items-center justify-between gap-4 py-5 transition-colors"
                  data-testid={`service-${i}`}
                >
                  <div className="flex items-center gap-5">
                    <span className="font-display text-sm font-semibold text-teal">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display text-lg font-medium text-foreground transition-transform duration-300 group-hover:translate-x-2 sm:text-2xl">
                      {service}
                    </span>
                  </div>
                  <ArrowUpRight className="h-5 w-5 shrink-0 text-muted-foreground transition-all duration-300 group-hover:text-teal group-hover:rotate-45" />
                </motion.a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
